export default "__VITE_ASSET__DRY43x7W__"